/**
 * « Ce contact est-il DEJA pret a appeler ? »
 *
 * Le bouton « Marquer comme pret a appeler » de la fiche contact s'affichait
 * des que le contact n'etait ni placeholder ni DNC, donc aussi sur un contact
 * jamais appele, qui est deja pret : une action proposee qui ne change rien.
 *
 * La reponse ne se recalcule pas ici. Elle interroge `dialIntent`, l'autorite
 * qui classe un contact a partir de son dernier appel et d'un eventuel statut
 * pose a la main : « fresh » EST l'etat pret a appeler. La pause et le DNC
 * sont lus a part parce qu'ils sortent le contact de la file sans passer par
 * l'intention (`canCall`), et parce que la fiche leur donne deja chacun leur
 * bloc et leur bouton de sortie.
 */

import { dialIntent } from './dialRules';
import { isSnoozed } from './snooze';
import { PROSPECT_STATUS } from './prospectStatus';

export function estPretAAppeler(prospect: any, dernierAppel: any): boolean {
    if (!prospect) return false;
    if (prospect.status === PROSPECT_STATUS.DO_NOT_CALL || prospect.do_not_call === true) return false;
    if (prospect.status === PROSPECT_STATUS.PLACEHOLDER) return false;
    if (isSnoozed(prospect)) return false;
    return dialIntent(prospect, dernierAppel) === 'fresh';
}
